import { SYMBOL_HYPHEN } from '../../../constants/common'
import Text from '../../Text'

import * as styles from './FormFieldReadOnlyTextValue.module.css'

function FormFieldReadOnlyTextValue({
  className = styles.FormFieldReadOnlyTextValue,
  disabled,
  value,
}) {
  return (
    <Text className={className} disabled={disabled}>
      {value || SYMBOL_HYPHEN}
    </Text>
  )
}

export default FormFieldReadOnlyTextValue
